export const LogType  = {
  ERROR: 1,
  WARNING: 2,
  NOTICE : 3,
  LOG: 4,
};
